import { message } from "antd";

class responseMessage {
  static error = (value) => {
    message.error(value)
  };
  static success = (value) => {
    message.success(value)
  };
  static warn = (value) => {
    message.warn(value)
  }
}

export default responseMessage;
